import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {

	isMqyStation: false,
	
	/*RO 신청현황 시작*/
	searchParams: SEARCH_PARAMS(),
	roApcnList: [],
	prcsStepList: [], //조회조건 처리단계
	ceqSearchTypeList: [], //조회조건 정비유형
	outBoundStatusList: [],
	prcsRsltList: [], //조회조건 처리결과
	roDdList: [], //조회조건 날짜유형 검색조건
	sCtypeList: [], //조회조건 날짜유형 검색조건
	rptpStList: [],
	pagingInfo: PAGING_INFO(),
	/*RO 신청현황 끝*/

	/*RO 등록 팝업관련 state 시작*/
	roApcnPopUp: RO_APCN_POPUP(), //RO신청 팝업조회
	saveRoApcn: RO_APCN_POPUP(), //RO신청 저장State
	roApcnSwapPartsList: [], //RO신청팝업 교환부품정보
	roApcnOtherFeeList: [],
	roApcnCommentList: [], //审批评论列表
	fileList: [], //파일첨부 디테일 조회할때
	occuRegnListPop: [], //RO신청팝업 PWA기초 정보 발생지역
	causCdListPop: [], //RO신청팝업 PWA기초 정보 원인코드
	ctypeList: [], //RO신청팝업 PWA기초 정보 Ctype
	feeTypeList: [],
	ceqTypeList: [], //RO신청팝업 정비유형
	isSaveFlag: false,
	isDelPwaCompInitFlag: false,
	isDelPwaCompInitFlag2: false,
	isDelCamPaignCompInitFlag: false,
	isDelCeqDtCompInitFlag: false,
	prcStateCd: '',
	beRoNo: '' /*임시저장시 임시로 담아놓은 Rono */,
	bePrcsStepr: '' /*임시저장시 임시로 담아놓은 Ro처리단계코드 */,
	bePrcsStempNmr: '' /*임시저장시 임시로 담아놓은 Ro처리단계명 */,
	chkPmcIdCampNoList: '' /*pmcId가져올때 pmcId기준 캠페인 목록조회*/,
	selectedPmcId: '' /*차량정보 팝업에서 선택한 pmcId*/,
	selectedRoApcnList: [], //체크박스로 선택한 Ro List

	/*RO 등록 팝업관련 state 끝*/

	/*******************************************얼그레이아이스티 ******************************/
	/* 캠페인 목록 팝업 시작 */
	cmpnMstList: [], //캠페인 목록
	opCodeList: [], //op코드 리스트
	cmpnPartList: [], //교환부품 리스트
	selectedCmpnNm: '', // 팝업에서 선택한 캠페인명
	currentCmpnCd: '', //선택한 캠페인 코드
	currentCmpnNm: '', //선택한 캠페인 명
	currentOpCode: '', //선택한 op코드
	currentOpNm: '', //선택한 op코드명
	currentCausPartNo: '', //선택한 원인부품
	currentCausPartNm: '', //선택한 원인부품명
	currentCausCd: '', //선택한 원인코드
	currentCausNm: '', //선택한 원인코드명
	currentPhmnCd: '', //선택한 현상코드
	currentPhmnNm: '', //선택한 현상코드명
	currentCpnyNm: '', //선택한 협력사명
	currentdlvgNm: '', //선택한 실납품사명

	currentMtrlCst: '', //선택한 자재비
	currentWags: '', //선택한 공임비
	currentIncdCst: '', //선택한 부대비
	currentAmt: '', //선택한 총금액
	currentCmpnStdt: '', //선택한 캠페인 시작일
	currentCmpnEndDt: '', //선택한 캠페인 종료일

	selectedCmpnMstList: [], //선택한 캠페인 상세
	popupSelected: [], //팝업에서 선택한 교환부품 리스트
	cmpnMstPartSelected: [], //선택한 교환부품 리스트
	pwaApcnSelectedList: [], // 선택한 pwa 목록 리스트
	cmpnMstSearchParams: CMPN_MST_SEARCH_PARAMS()

	/* 캠페인 목록 팝업 끝*/

	/*******************************************얼그레이아이스티 ******************************/
};

function RO_APCN_POPUP() {
	return {
		roNo: '', //RO번호
		prcsStepr: '' /* RO처리단계 */,
		aplcIdr: '' /* Ro신청자ID */,
		aplcDdr: '' /* RO신청일 */,
		dcsnIdr: '' /* RO확정자ID */,
		dcsnDdr: '' /* RO확정일 */,
		roFileId: '' /*RO전용 파일Id */,
		prcsRsltr: '', //Ro처리결과,
		prcsRsltNmr: '', //Ro처리결과명
		prcsStepNmr: '', //ro처리상태명
		cmpnNo: '', //캠페인번호
		cmpnNm: '', //캠페인명
		opCd: '', //op코드
		opNm: '', //op코드명
		rptpNo: '', //고품분석번호
		mtrlCst: '', //자재비
		wags: '', //공임비
		incdCst: '', //부대비
		dlrCpnyFee: '',
		warrantyFee: '',
		nonWarrantyFee: '',
		ceqStrtDd: '', //정비시작일
		ceqEndDd: '', //정비완료일
		camCpnyMm: '', //켐페인 협력사
		camCpnyCd: '', //켐페인 협력사
		ceqType: '', //정비유형
		pwaNo: '', //PWA번호
		prcsStepNm: '', //처리단계명
		prcStep: '', //처리단계
		aplcDd: '', //신청일
		dcsnDd: '', //확정일
		carVin: '', //VIN no
		pmcNo: '', //PMC no
		pmcId: '', //PMC Id
		oemSaleDd: '', //고객사판매일
		vehlNm: '', //차종
		custNm: '', //판매사
		saleRegnNm: '', //판매지역
		flclSpcNm: '', //연료전지사양
		grntPlcy: '', //보증정책
		dlrCpnyCd: '', //딜러점코드
		dlrCpnyNm: '', //딜러점명
		rprRegn: '', //수리지역
		occuRegn: '', //발생지역
		dtlRegn: '', //지역세부
		causPartNo: '', //원인부품
		causPartNm: '', //원인부품명
		carTypeNm: '', //차종유형
		usePrd: '', //사용기간
		milg: '', //주행거리
		wrntStrtDd: '', //품질보증 시작일
		wrntEndDd: '', //보증만료일
		licensePlate: '',
		dgnDd: '', //진단일자
		causCd: '', //원인코드
		phmnCd: '', //현상코드
		phmnNm: '', //현상코드명
		ctype: '', //ctypeCd
		dtc1: '', //dtc1
		dtc2: '', //dtc2
		dtc3: '', //dtc3
		prtlSbc: '', //특이사항
		usePrdPo: '', //보증사용기간
		milgPo: '', //보증주행거리
		prcsRslt: '', //처리결과,
		fileId: '', //파일Id
		btnTsAuth: false, // 임시저장버튼권한
		btnApAuth: false, //신청버튼권한
		btnDelAuth: false, //삭제버튼권한
		btnApprAuth: false, //승인,반려,기각버튼권한
		readOnlyAuth: false, //리드온리구분값 신청일경우 입력못하게 함.
		readOnlyAuth1: false,
		readOnlyAuth3: false, //캠페인시 정비유형  Ctype 선택 못하게 하려고 처리함.
		dlrCpnyReadOnlyAuth: false,
		fileList: [], //파일첨부
		delFileList: [], //삭제할파일첨부
		pwaFileId: '', //pwa첨부된파일ID
		erpSaleDd: '', //HTWO판매일,
		pwaRegCnt: '', //임시저장 또는 신청시 pmcId, 원인부품번호, 주행거리를 기준으로 PWA 번호 등록건수
		preRegPwaNo: '', //임시저장 또는 신청시 pmcId, 원인부품번호, 주행거리를 기준으로 PWA 번호
		dlvgNm: '', //캠페인 실납품사.
		pwaEndPartStdCst: '', //PWA신청 작업내용 END부품 기준금액 변수관리에서 가져옴,
		selUsedYear: '', //PMCID에서 선택할때 진단일자와 OEM판매일을 가지고 조회해서 사용기간년을 가져옴
		cmpnStrDd: '', //캠페인 시작일자

		cmpnEndDd: '', //캠페인 종료일자
		jvSaleDd:'',
		jvCpnyNm:''	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SEARCH_PARAMS() {
	return {
		roNo: '', //RO번호
		dlrCpnyCd: '' /*딜러점*/,
		prcStepGb: '' /*처리단계*/,
		causPartNo: '' /*원인부품번호*/,
		ceqType: '' /*정비유형*/,
		prcRsltCd: '' /*처리결과*/,
		prcPwaDd: '' /* 검색날짜구분값*/,
		startAplcDd: startDt /*일자초기값from*/,
		endAplcDd: endDt /*일자초기값to*/,
		roStartDt: '',
		roEndDt: '',
		ctype: '' /*cType*/,
		rptpStCd: '' /*고품회수상태 */,
		cmpnNo: '',
		aplcNm: '',
		carVin: '',
		pmcId: '',
		causOpCd: '',
		outBoundStatus: ''
	};
}
function CMPN_MST_SEARCH_PARAMS() {
	return {
		cmpnNo: '', //캠페인번호
		pmcId: '' //pmcId
	};
}

export { SEARCH_PARAMS, RO_APCN_POPUP, PAGING_INFO, CMPN_MST_SEARCH_PARAMS };
